<div class="fixed z-[999] bottom-8 right-8">
  <button
    class="soft-button primary !rounded-full w-12 h-12 flex items-center justify-center text-center !shadow-xl"
    (click)="openCloseOverlay()"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
  >
    <soft-icon
      name="fa-solid fa-message text-xl font-bold text-primary-contrast"
    ></soft-icon>
  </button>
</div>

<ng-template
  cdkConnectedOverlay
  cdkConnectedOverlayPush
  cdkConnectedOverlayBackdropClass="soft-backdrop"
  cdkConnectedOverlayTransformOriginOn="bottom right"
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayOffsetY]="-4"
  [cdkConnectedOverlayOpen]="overlayOpen()"
  [cdkConnectedOverlayPositions]="positions"
  [cdkConnectedOverlayMinWidth]="264"
  (detach)="overlayOpen.set(false)"
  (overlayKeydown)="onOverlayKeydown($event)"
  (backdropClick)="openCloseOverlay()"
>
  <div
    animate.enter="enter-animation"
    animate.leave="leave-animation"
    class="bg-surface grid grid-rows-[auto,1fr,auto] w-full rounded-lg -z-1 overflow-clip shadow-xl border border-border border-1 min-h-[400px] lg:min-h-[472px] max-h-[472px] w-full md:min-w-[468px] lg:min-w-[528px] lg:max-w-[50vw]"
  >
    <header
      class="border-b border-b-border border-b-1 py-2 px-3 flex items-center justify-between"
    >
      <h6 class="text-base font-semibold">SOFTLINE Chatbot</h6>
      <button
        (click)="openCloseOverlay()"
        class="cursor-pointer rounded w-6 h-full group flex items-center justify-center hover:bg-surface-tertiary"
      >
        <soft-icon
          name="fa-regular fa-xmark text-sm text-lighter group-hover:text-color"
        ></soft-icon>
      </button>
    </header>

    <ol class="flex flex-col gap-4 p-2 overflow-y-auto">
      @defer {
        <soft-lottie-animation-player
          [loop]="true"
          (play)="animationPlayingStarted()"
          (loaded)="animationPlayingStarted()"
          class="min-w-[80px] min-h-[180px] max-w-[180px] -mt-2 flex items-center justify-end"
          src="./assets/animations/ai.lottie"
        ></soft-lottie-animation-player>
      } @error {
        <div class="text-danger-600 min-h-[180px]">...</div>
      }

      @for (message of messages(); track $index) {
        <div
          class="flex items-center relative w-full"
          (mouseenter)="_hoverIndex.set($index)"
          (mouseleave)="_hoverIndex.set(-1)"
          [class.justify-start]="message.response"
          [class.justify-end]="!message.response"
        >
          <li
            #listElement
            class="text-sm items-start grow-0 rounded px-1.5 py-1 max-w-[90%]"
            softObserveElementSize
            (sizeChangeNoDebounce)="sizeChange$.next($event)"
            [class.bg-primary]="!message.response"
            [class.text-primary-contrast]="!message.response"
            [class.bg-surface-tertiary]="message.response"

          >
<!--
            <div [innerHTML]="
              message.response &&
              $last &&
              !(_messages().length > 0 && currentMessages().length <= 1)
                ? (((message.text | typewriterEffect: scrollToEndElement | async) ?? '') | markdown | async)
                : (message.text | markdown | async)
            ">
              </div>-->

            <markdown [data]="message.response &&
              $last &&
              !(_messages().length > 0 && currentMessages().length <= 1)
                ? ((message.text | typewriterEffect: scrollToEndElement | async) ?? '')
                : message.text"></markdown>

            @if(isDefinedNotEmpty(message.link)) {
              <button (click)="navigateToLink(message.link)" class="text-primary-400 underline italic">
                {{('Weitere Info...' | typewriterEffect: scrollToEndElement | async)}}
              </button>
            }
          </li>

          @if (hoverIndex() === $index) {
            @if (message.response) {
              <button
                animate.enter="fade-in"
                animate.leave="fade-out"
                class="absolute text-base text-lighter hover:bg-surface-tertiary hover:text-color flex items-center justify-center px-1 py-0.5 rounded"
                [style.left.px]="listElement.getBoundingClientRect().width + 6"
                (click)="copyTextToInput(message.text)"
              >
                <soft-icon name="fa-regular fa-arrows-repeat"></soft-icon>
              </button>
            } @else {
              <span
                animate.enter="fade-in-right"
                animate.leave="fade-out-right"
                class="absolute text-base text-lighter hover:bg-surface-tertiary hover:text-color flex items-center justify-center px-1 py-0.5 rounded"
                [style.right.px]="listElement.getBoundingClientRect().width + 6"
                (click)="copyTextToInput(message.text)"
              >
                <soft-icon name="fa-regular fa-arrows-repeat"></soft-icon>
              </span>
            }
          }
        </div>
      }

      @if (requestInProgress()) {
        <li
          class="text-sm italic self-start opacity-50 items-start grow-0 rounded px-1.5 py-1"
        >
          {{ typewriterLoadingTextEffect$ | async }}
        </li>
      }

      <!-- This is needed for the auto-scroll behaviour -->
      <div class="block select-none max-h-[1px]" #end>&nbsp;</div>
    </ol>

    @let lastMessageButtons = messages()[messages().length-1].buttons;
    @if(isDefinedNotEmpty(lastMessageButtons)) {
      <div class="flex flex-row gap-2 overflow-x-auto max-w-inherit !mx-2 mb-2 mt-2">
        @for (button of lastMessageButtons; track button) {
          <div
            class="text-xs bg-surface-tertiary rounded p-1 cursor-pointer"
            (click)="copyTextToInput(button)">
            {{button}}
          </div>
        }
      </div>
    }

    <div
      cdkTrapFocus
      cdkTrapFocusAutoCapture
      class="border-t border-t-border w-full shadow-sm flex items-center justify-between gap-1"
    >
      <input
        softHasFocus
        #focusDir="softHasFocus"
        cdkTrapFocusInitial
        (keydown.enter)="onSubmit(input?.value ?? undefined)"
        type="text"
        autofocus
        [(ngModel)]="messageInput"
        #input
        class="px-3 py-2 text-base resize-none w-full"
        placeholder="Nachricht eingeben..."
      />

      @let disabled = (input?.value?.trim?.()?.length ?? 0) < 1 || requestInProgress();

      <div class="flex items-center gap-2">
        @if (focusDir.hasFocusDebounced() && (input?.value?.trim?.()?.length ?? 0) > 0) {
          <button
            class="group size-6 flex items-center justify-center cursor-pointer"
            (click)="
              $event.preventDefault();
              $event.stopPropagation();
              input.focus();
              copyTextToInput('')
            "
          >
            <soft-icon
              name="fa-regular fa-delete-left text-base text-lighter group-hover:text-danger-600"
            ></soft-icon>
          </button>
        }

        <button
          (click)="onSubmit(input?.value ?? undefined)"
          [style.border-bottom-right-radius.px]="5"
          class="bg-primary disabled:bg-primary-400 hover:bg-primary-600 disabled:hover:bg-primary-400 rounded-sm my-0.5 mr-0.5 !w-14 !h-12 flex items-center justify-center text-center"
          [class.cursor-wait]="requestInProgress()"
          [class.cursor-pointer]="!requestInProgress()"
          [disabled]="disabled"
        >
          @if (requestInProgress()) {
            <svg
              width="24"
              class="fill-current text-primary-contrast"
              height="24"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <style>
                .spinner_b2T7 {
                  animation: spinner_xe7Q 0.8s linear infinite;
                }
                .spinner_YRVV {
                  animation-delay: -0.65s;
                }
                .spinner_c9oY {
                  animation-delay: -0.5s;
                }
                @keyframes spinner_xe7Q {
                  93.75%,
                  100% {
                    r: 3px;
                  }
                  46.875% {
                    r: 0.2px;
                  }
                }
              </style>
              <circle class="spinner_b2T7" cx="4" cy="12" r="3" />
              <circle class="spinner_b2T7 spinner_YRVV" cx="12" cy="12" r="3" />
              <circle class="spinner_b2T7 spinner_c9oY" cx="20" cy="12" r="3" />
            </svg>
          } @else {
            <soft-icon
              name="fa-regular fa-arrow-right text-base font-semibold text-primary-contrast"
            ></soft-icon>
          }
        </button>
      </div>
    </div>
  </div>
</ng-template>
